export default function (fileStr: string, filename: string, mimeType = "text/plain") {
    const blob = new Blob([fileStr], { type: mimeType });
    const elem = window.document.createElement("a");
    elem.href = window.URL.createObjectURL(blob);
    elem.download = filename;
    document.body.appendChild(elem);
    elem.click();
    document.body.removeChild(elem);
}